<template>
  <span
    v-tooltip="{
      content: tooltipText,
      placement: 'left',
    }"
    data-cy="expand-collapse-all"
    class="flex cursor-pointer items-center justify-center text-headline"
  >
    <icon-button
      view-box="0 -4 15 24"
      :icon="!isOpen ? ExpandAllIcon : CollapseAllIcon"
    />
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import CollapseAllIcon from "@/components/CollapseAllIcon.vue";
import ExpandAllIcon from "@/components/ExpandAllIcon.vue";
import IconButton from "@/components/ui/buttons/IconButton.vue";

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const tooltipText = computed(() =>
  props.isOpen
    ? t("COMMON.COLLAPSE_TABLES_TOOLTIP")
    : t("COMMON.EXPAND_TABLES_TOOLTIP")
);
</script>
